import { jsx as _jsx } from "react/jsx-runtime";

function SvgAttach() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.692 4.2l-3.479 3.5a1.007 1.007 0 01-1.418.009.994.994 0 01-.008-1.41l3.481-3.503.004-.004c1.989-1.978 4.978-1.433 6.729.308 1.798 1.789 2.122 4.66.177 6.595l-.002.002-3.987 3.993c-.39.39-1.025.393-1.418.005a.994.994 0 01-.005-1.41l3.99-3.996.002-.003c1.035-1.03.975-2.631-.175-3.776-1.198-1.19-2.897-1.295-3.89-.31zM7.72 20.2l4.358-4.105a1.006 1.006 0 011.418-.004.993.993 0 01.004 1.41l-4.36 4.107-.004.004c-1.994 1.973-4.981 1.42-6.727-.326-1.794-1.793-2.11-4.665-.16-6.596h.002l3.997-3.984a1.007 1.007 0 011.418 0 .994.994 0 01.002 1.41l-4 3.985-.003.002c-1.038 1.027-.982 2.63.165 3.776 1.194 1.195 2.894 1.304 3.89.32zm7.49-9.992a1 1 0 10-1.414-1.414l-5 5a1 1 0 101.413 1.414l5.001-5z"
    }, void 0)
  }), void 0);
}

export default SvgAttach;